import Constant from "@/common/constant/Constant";
import Utils from "@/common/utils/utils";
import { getFieldListInForm, getFormListByProject } from "@/service/formManagementService";
import SystemField, { TmpHiddenSysfieldInCreateTicket } from '@/common/constant/SystemField';
import { unregisterField } from "@/component/ticketList/handler/TicketHandler";
import { createNewAnonymousQaAPI, createTicketRecord, createNewTicketAPI } from "@/service/ticketService";
import localStorageUtil from "@/common/utils/localStorageUtil";
import { uploadFileToS3 } from "@/component/common/UploadFiles";
import { cloneDeep } from "lodash";
import { getPublicAPI } from '@/service/publicService';
import { validateErrorTicket, validateExceedSizeOfFieldTicket } from '@/component/common/ValidateTicket';

export const sortListByOrder = (listForm, projectId) => {
    return listForm.sort((formA, formB) => {
        let orderA = JSON.parse(formA.order) ? JSON.parse(formA.order)[projectId] : null;
        let orderB = JSON.parse(formB.order) ? JSON.parse(formB.order)[projectId] : null;

        return orderA - orderB;
    })
}

// /**
//  * getListFormQAOfProject with sort by order
//  * @param {*} API 
//  * @param {*} corporationId 
//  * @param {*} projectId 
//  * @returns 
//  */
// export const getListFormQAOfProject = async (API, corporationId, projectId) => {
//     let formQAList = [];

//     const formOfProjectList = await getFormListByProject(
//         API,
//         corporationId,
//         projectId,
//         Constant.AUTH_MODE_API_KEY
//     );
//     let listFormQaOfProject = formOfProjectList.filter(
//         (form) => form.type === Constant.FORM_TYPE.FORM_REQ_QA
//     );
//     formQAList = sortListByOrder(listFormQaOfProject, projectId);

//     return formQAList;
// }

export const getListCustomFiledOfForm = async (formStructure,API,corporationId) => {
    let fieldIdList = [];
    if (!Utils.isEmptyObject(formStructure)) {
        for (const fieldNumber in formStructure) {
            if (formStructure.hasOwnProperty(fieldNumber)) {
                if (formStructure[fieldNumber].hasOwnProperty('field')) {
                    fieldIdList.push(formStructure[fieldNumber]['field']);
                }
            }
        }

        if (Utils.isEmptyArray(fieldIdList)) {
            return [];
        }
        
        // get detail list custom field by with id list
        const customFieldDetailList = await getFieldListInForm(
            API,
            corporationId,
            fieldIdList,
            Constant.AUTH_MODE_API_KEY
        );

        return customFieldDetailList;
    }
};

export const getFormFieldData = (formStructure, fieldList) => {
    let formData = [];
    if (!Utils.isEmptyObject(formStructure)) {
        for (const fieldNumber in formStructure) {
            if (formStructure.hasOwnProperty(fieldNumber)) {
                let fieldData = {};
                let fieldId = '';
                let formField = formStructure[fieldNumber];

                if (
                    formStructure[fieldNumber].hasOwnProperty('field') &&
                    !Utils.isEmptyArray(fieldList)
                ) {
                    fieldId = formStructure[fieldNumber]['field'];
                    fieldData = fieldList.find((customField) => customField.id === fieldId);
                    fieldData.structure = Utils.convertJSONDataToObject(fieldData.structure);
                } else if (
                    formStructure[fieldNumber].hasOwnProperty('sysfield') &&
                    !Utils.isEmptyArray(SystemField)
                ) {
                    fieldId = formStructure[fieldNumber]['sysfield'];
                    fieldData = SystemField.find((systemField) => systemField.id === fieldId);
                }

                if (!Utils.isEmptyObject(fieldData)) {
                    fieldData.fieldId = fieldId;
                    fieldData.fieldLabel = fieldData.name;
                    fieldData.structure.required = formField.required;
                    fieldData.structure.publicForCustomer = formField.publicForCustomer;
                    formData.push(fieldData);
                }
            }
        }
    }
    const indexOfAttachmentFile = formData?.findIndex(field => {
        return field?.sysField === 'attachments'
    })

    //attachment always at bottom
    if (indexOfAttachmentFile !== -1) {
        if (indexOfAttachmentFile >= 0 && indexOfAttachmentFile < formData?.length) {
            const element = formData.splice(indexOfAttachmentFile, 1)[0];
            formData.push(element);
        }
    }

    return formData;
};

export const onChangeSelectedForm = async (argsAll, selectedFormDetail) => {
    argsAll.setIsLoading(true);

    if (!Utils.isEmptyArray(argsAll.fieldListData)) {
        unregisterField(
            argsAll.fieldListData,
            argsAll.unregisterCreateTicket,
            argsAll.resetValuesCreateTicket
        );
        
        // Reset attact file
        argsAll.setValueCreateTicket(Constant.FORM_FILE_UPLOAD_LIST_INPUT_NAME, []);
        argsAll.setFileUploadList([]);
    }
    argsAll.setSelectedForm(selectedFormDetail.id);

    argsAll.setSelectedFormInfo(selectedFormDetail);
    const formStructure = Utils.convertJSONDataToObject(selectedFormDetail?.structure);

    // get field list detail in form 
    let params = {
        getApiType: Constant.GET_API_PUBLIC_TYPE.GET_FIELD_IN_FORM_FOR_ANONYMOUS_QA,
        formId: selectedFormDetail.id
    };
    let result = await getPublicAPI(argsAll.API, params);

    if (result.success) {
        // const customFieldList = await getListCustomFiledOfForm(
        //     formStructure,
        //     argsAll.API,
        //     selectedFormDetail.affiliationOrganization
        // );

        let data = Utils.convertJSONDataToObject(result.payload);
        let customFieldList = data.fieldListResponse;
        let getFieldListResult = getFormFieldData(formStructure, customFieldList);
        getFieldListResult = getFieldListResult.filter(
           field => {
                if (
                    (Number(field?.structure?.publicForCustomer) !==
                        Constant.SETTING_PUBLIC_FOR_CUSTOMER.HIDE ||
                        field?.type === Constant.FORM_TYPE.FIELD_WORKFLOW) &&
                    !TmpHiddenSysfieldInCreateTicket.includes(field?.sysField)
                )
                    return true;
               
               return false;
           }
        );
        getFieldListResult = Array.from(getFieldListResult, field => {
            if (
                Number(field.structure.publicForCustomer) ===
                Constant.SETTING_PUBLIC_FOR_CUSTOMER.ONLY_VIEW
            ) {
                field.structure.required = false;
            }
            return field;
        });

        //filter inactive fields from project
        getFieldListResult = getFieldListResult?.filter(field => {
            return (
                field?.definition == Constant.FORM_DEFINITION.SYSTEM ||
                field?.usingProjects?.includes(selectedFormDetail?.affiliationProject)
            );
        });
        
        argsAll.setFiledListData([...getFieldListResult]);
        argsAll.setFormSaveData(null);
    }

    argsAll.setIsLoading(false);
}

export const onSubmitCreateAnonymousNormal = async (
    argsAll,
    formData,
    infoB2C,
    affiliationOrganization,
    affiliationProject,
    fieldListData,
    anonymousUserInfo
) => {
    if(argsAll?.setIsLoading) {
        argsAll?.setIsLoading(true);
    }

    let status = '';
    const statusField = fieldListData.find((fieldData) => fieldData.type === Constant.FORM_TYPE.FIELD_WORKFLOW);
    if (!Utils.isEmptyObject(statusField)) {
        status = statusField.fieldId;
    }
    const fields = await Utils.getCustomFieldValueInFormData(formData, fieldListData);

    // validate exceed max size
    if (validateExceedSizeOfFieldTicket(fieldListData, argsAll?.setFiledListData, fields, argsAll.setErrorMessageHeader)) {
        if(argsAll?.setIsLoading) {
            argsAll?.setIsLoading(false);
        }
        return;
    }

    formData.affiliationOrganization = affiliationOrganization;

    let uploadFileS3Result = {
        fileListSuccess: [],
        suffixOfAttachments: {},
        listFileError: []
    };

    uploadFileS3Result = await handleUploadFilesForAnonymousTicket(
        formData,
        argsAll.setFileUploading,
    ); 
    const requestBody = {
        createTicketRequestDto: {
            liveOrArchived: Constant.LIVE_OR_ARCHIVED.LIVE,
            public: Constant.TICKET_PUBLIC.PUBLIC,
            corporationOrigin: affiliationOrganization,
            createUserId: infoB2C?.id,
            projectOrigin: infoB2C?.projectInuse,
            projectTarget: [affiliationProject],
            corporationTarget: affiliationOrganization,
            ticketType: Constant.TICKET_TYPE.QA,
            type: formData?.formSelected,
            affiliationOrganization,
            affiliationProject,
            status,
            customer: infoB2C?.id,
            fields,
            fileListSuccess: uploadFileS3Result?.fileListSuccess,
            suffixOfAttachments: JSON.stringify(uploadFileS3Result?.suffixOfAttachments),
            anonymousUserInfo: JSON.stringify(anonymousUserInfo)
        }
    };
    const createTicketResponse = await createNewTicketAPI(argsAll.API, requestBody, Constant.AUTH_MODE_API_KEY);
    const errors = createTicketResponse.errors
    if (!createTicketResponse?.id) {
        if(argsAll?.setIsLoading) {
            argsAll?.setIsLoading(false);
        }
        return {
            data: null,
            errors: errors
        }
    }
    if(argsAll?.setIsLoading) {
        argsAll?.setIsLoading(false);
    }
    return {
        data: {...createTicketResponse},
        errors: errors
    };
};


export const onSubmitCreateAnonymousQa = async (
    argsAll,
    formData,
    anonymousUserInfo,
    affiliationOrganization,
    affiliationProject,
    fieldListData,
    infoB2CInCorp,
    forceCreate = false,
    supportChatThreadId=''
) => {
    if(argsAll?.setIsLoading) {
        argsAll?.setIsLoading(true);
    }
   let customer = Constant.ANONYMOUS_USER_ID;
   const creator = Constant.ANONYMOUS_USER_ID;
   let projectOrigin = Constant.ANONYMOUS_USER_ID;
    let status = '';
    const statusField = fieldListData.find((fieldData) => fieldData.type === Constant.FORM_TYPE.FIELD_WORKFLOW);
    if (!Utils.isEmptyObject(statusField)) {
        status = statusField.fieldId;
    }
    const fields = await Utils.getCustomFieldValueInFormData(formData, fieldListData);

    formData.affiliationOrganization = affiliationOrganization;

    if (infoB2CInCorp && !Utils.isEmptyObject(infoB2CInCorp)) {
        customer = infoB2CInCorp.id;
        projectOrigin = infoB2CInCorp.projectInuse;
        anonymousUserInfo = {
            ...anonymousUserInfo,
            mailAddress : infoB2CInCorp.mail
        };
    }

    let uploadFileS3Result = {
        fileListSuccess: [],
        suffixOfAttachments: {},
        listFileError: []
    };

    uploadFileS3Result = await handleUploadFilesForAnonymousTicket(
        formData,
        argsAll.setFileUploading
    ); 

    const requestBody = {
        createAnonymousQaRequestDto: {
            liveOrArchived: Constant.LIVE_OR_ARCHIVED.LIVE,
            public: Constant.TICKET_PUBLIC.PUBLIC,
            outline: formData.outline,
            corporationOrigin: affiliationOrganization,
            description: formData.description,
            createUserId: creator,
            projectOrigin: projectOrigin,
            anonymousQaStatus: Constant.ANONYMOUS_TICKET_STATUS.WAITING_APPROVE,
            type: formData?.formSelected,
            projectTarget: [affiliationProject],
            corporationTarget: affiliationOrganization,
            ticketType: Constant.TICKET_TYPE.QA,
            anonymousUserInfo: JSON.stringify(anonymousUserInfo),
            affiliationOrganization,
            affiliationProject,
            customer,
            creator,
            status,
            fields,
            fileListSuccess: uploadFileS3Result?.fileListSuccess,
            suffixOfAttachments: JSON.stringify(uploadFileS3Result?.suffixOfAttachments),
            forceCreate,
            supportChatThreadId
        },
    };
    const createTicketResponse = await createNewAnonymousQaAPI(argsAll.API, requestBody);
    const newTicket = createTicketResponse.data?.createAnonymousQa
    const errors = createTicketResponse.errors
    if (!newTicket?.id) {
        if(argsAll?.setIsLoading) {
            argsAll?.setIsLoading(false);
        }
        return {
            data: null,
            errors: errors
        }
    }

    if(argsAll?.setIsLoading) {
        argsAll?.setIsLoading(false);
    }
    return {
        data: {...newTicket},
        errors: errors
    };
};

export const uploadTicketFileToS3 = async (formData,setFileUploading) => {
    let fileListSuccess = [];
    let listFileError;
    let suffixOfAttachments = {};
    let pushFileProcessList = [];
    let listFileInfo = [];
    let listFileExtension = [];
    let fileNameObj = {};
    const uploadTime = new Date().getTime();

    const affiliationOrganization = formData?.affiliationOrganization
        ? formData?.affiliationOrganization
        : localStorageUtil.getCorporationDomain();

    for (const fileUpload of formData[Constant.FORM_FILE_UPLOAD_LIST_INPUT_NAME]) {
        let fileInfo = cloneDeep(fileUpload);
        const lastDot = fileInfo.file.name.lastIndexOf('.');
        const fileExtension = fileInfo.file.name.substring(lastDot + 1).toLowerCase();
        listFileExtension.push(fileExtension);
        if (fileNameObj[`${fileInfo.file.name}`]) {
            //edit ticket add same file exist
            const timeOfUpload = new Date().getTime();
            const fileName =
                fileInfo.file.name.substring(0, lastDot) +
                `${timeOfUpload}` +
                `(${fileNameObj[`${fileInfo.file.name}`]})` +
                fileExtension;
            fileInfo.key = `tmp/${affiliationOrganization}/${uploadTime}/${fileName}`;
            fileNameObj[`${fileInfo.file.name}`] = fileNameObj[`${fileInfo.file.name}`] + 1;
        
        } else {

            fileNameObj[`${fileInfo.file.name}`] = 1;
            fileInfo.key = `tmp/${affiliationOrganization}/${uploadTime}/${fileInfo.file.name}`;
        }
        listFileInfo.push(fileInfo);
        pushFileProcessList.push(uploadFileToS3(setFileUploading, fileInfo));
    }

    let pushFileProcessListResult = await Promise.all(pushFileProcessList);

    for (let i = 0; i < pushFileProcessListResult.length; i++) {
        let fileInfo = listFileInfo[i];
        if (pushFileProcessListResult[i]) {
            fileListSuccess.push({
                fileUrl: fileInfo.key,
                fileSize: fileInfo.file.size.toString(),
                fileName: fileInfo.file.name
            });
            if (suffixOfAttachments[`${listFileExtension[i]}`]) {
                suffixOfAttachments[`${listFileExtension[i]}`] =
                    suffixOfAttachments[`${listFileExtension[i]}`] + 1;
            } else {
                suffixOfAttachments[`${listFileExtension[i]}`] = 1;
            }
        } else {
            listFileError.push(fileInfo.file.name);
        }
    }

    return {
        fileListSuccess,
        listFileError,
        suffixOfAttachments
    };
};

export const handleUploadFilesForTicket = async (
    formData,
    setFileUploading
) => {
    let resUpload = {
        fileListSuccess: [],
        suffixOfAttachments: {},
        listFileError: []

    }
    if (formData?.fileUploadList?.length > 0) {
        resUpload = await uploadTicketFileToS3(
            formData,
            setFileUploading
        );
    }
    return resUpload;
};


/**
 * handleUploadFilesForAnonymousTicket
 * @param {*} API 
 * @param {*} formData 
 * @param {*} newTicket 
 * @param {*} setIsModalUploadFileError 
 * @param {*} setFileUploading 
 * @param {*} ticketType 
 * @returns 
 */
const handleUploadFilesForAnonymousTicket = async (
    formData,

    setFileUploading
) => {
    if (!formData || !formData.fileUploadList || Utils.isEmptyArray(formData.fileUploadList))
        return;

    let resUpload = {
        fileListSuccess: [],
        suffixOfAttachments: {},
        listFileError: []
    };
    if (formData?.fileUploadList?.length > 0) {
        resUpload = await uploadTicketFileToS3(formData, setFileUploading);
    }

    return resUpload;
};
